export const CarouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        infinite: true,
        dots: true,
        centerPadding: '20%',
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        swipeToSlide: true,
        centerPadding: '20%',
      },
    },
  ],
}

export const MediaCarouselSettings = {
  dots: false,
  nextArrow: <MediaNextArrow />,
  prevArrow: <MediaPrevArrow />,
  responsive: [
    {
      breakpoint: 380,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 479,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 769,
      settings: {
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
  ],
}

const homeCarouselSlides = {
  SLIDES_TO_SCROLL: 4,
  SLIDES_TO_SHOW: 4,
  SLIDES_TO_SHOW_1024: 3,
  SLIDES_TO_SHOW_768: 3,
  SLIDES_TO_SHOW_MIN: 1,
  SLIDES_TO_SCROLL_1024: 3,
  SLIDES_TO_SCROLL_768: 3,
  SLIDES_TO_SCROLL_MIN: 1,
  MAX_NO_OF_SLIDES_TO_DISPLAY: 12,
  SPEECH_TITLES_DISPLAY_LIMIT: 4,
}

export const carouselSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: homeCarouselSlides.SLIDES_TO_SHOW,
  slidesToScroll: homeCarouselSlides.SLIDES_TO_SCROLL,
  initialSlide: 0,
  nextArrow: <button id="next" title="Next" />,
  prevArrow: <button id="previous" title="Previous" />,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: homeCarouselSlides.SLIDES_TO_SHOW_1024,
        slidesToScroll: homeCarouselSlides.SLIDES_TO_SCROLL_1024,
        infinite: true,
        dots: false,
        nextArrow: <button id="next" title="Next" />,
        prevArrow: <button id="previous" title="Previous" />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: homeCarouselSlides.SLIDES_TO_SHOW_1024,
        slidesToScroll: homeCarouselSlides.SLIDES_TO_SCROLL_1024,
        initialSlide: 2,
        arrows: true,
        nextArrow: <button id="next" title="Next" />,
        prevArrow: <button id="previous" title="Previous" />,
        infinite: true,
        dots: false,
        centerPadding: '20%',
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: homeCarouselSlides.SLIDES_TO_SHOW_MIN,
        slidesToScroll: homeCarouselSlides.SLIDES_TO_SCROLL_MIN,
        arrows: false,
        swipeToSlide: true,
        centerMode: true,
        centerPadding: '20%',
      },
    },
  ],
}

function MediaNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/right-arrow.svg) !important',
        height: '25px !important',
        top: '45%',
        right: '-45px',
      }}
      onClick={onClick}
    />
  )
}

function MediaPrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/left-arrow.svg) !important',
        height: '25px !important',
        top: '45%',
      }}
      onClick={onClick}
    />
  )
}

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/right-arrow.svg) !important',
        height: '25px !important',
        top: '20%',
        right: '-45px',
      }}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        content: 'url(/static/icons/left-arrow.svg) !important',
        height: '25px !important',
        top: '20%',
      }}
      onClick={onClick}
    />
  )
}
